import * as React from "react";
import FrozenIcon, { ProjectOrEnvironment } from "~/components/DeploymentFreezes/FrozenIcon";
import styles from "./style.module.less";
export default () => (<span className={styles.phaseIcon}>
        <FrozenIcon for={ProjectOrEnvironment.Environment}/>
    </span>);
